import { render, staticRenderFns } from "./AddressesList.vue?vue&type=template&id=61b95d50&scoped=true&"
import script from "./AddressesList.vue?vue&type=script&lang=js&"
export * from "./AddressesList.vue?vue&type=script&lang=js&"
import style0 from "./AddressesList.vue?vue&type=style&index=0&id=61b95d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b95d50",
  null
  
)

export default component.exports